// Angular
/*
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';
*/

// RxJS
//import 'rxjs';

// polyfills
import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
//import 'zone.js/dist/zone';